import { useEffect, useState } from 'react';
import { Input, Button } from '../../../shared/components';
import { getTurnoGeoRepository } from '../../../shared/services/turnoGeo/repositoryFactory';
import { NetworkReading, UserProfile } from '../../../shared/services/turnoGeo/types';
import { ReadingsTable, StabilitySummary } from './ReadingsTable';

const repo = getTurnoGeoRepository();

/** Configuración > Lecturas (Registrador): todas las lecturas guardadas por el personal, con filtros. */
export function ReadingsAdminTab() {
  const [rows, setRows] = useState<NetworkReading[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [people, setPeople] = useState<UserProfile[]>([]);
  const [userId, setUserId] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const load = () => {
    setIsLoading(true);
    repo
      .listReadings({ userId: userId || undefined, from: from || undefined, to: to || undefined, limit: 300 })
      .then(setRows)
      .finally(() => setIsLoading(false));
  };
  useEffect(() => {
    repo.listUserProfiles().then(setPeople).catch(() => setPeople([]));
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-4">
      <p className="text-xs text-ink-400">Lecturas que guardan las personas desde <strong>Registrador</strong>. Úsalas para verificar con cada empleado que su red se mantiene igual de un día a otro.</p>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-4">
        <label className="block text-sm">
          <span className="mb-1 block font-medium text-ink-700">Persona</span>
          <select className="w-full rounded-xl border border-ink-200 bg-surface px-3 py-3 text-sm" value={userId} onChange={(e) => setUserId(e.target.value)}>
            <option value="">Todas</option>
            {people.map((p) => (
              <option key={p.userId} value={p.userId}>{p.userFullName}</option>
            ))}
          </select>
        </label>
        <Input label="Desde" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
        <Input label="Hasta" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
        <div className="flex items-end"><Button fullWidth onClick={load}>Buscar</Button></div>
      </div>
      <StabilitySummary rows={rows} />
      <ReadingsTable rows={rows} isLoading={isLoading} showUser />
    </div>
  );
}
